export const ERROR_CODES = {
  '81723': 'Cardholder name is too long.',
  '83518': 'Credit card type is not accepted.',
  'FILE_SIZE_EXCEEDED': 'File is too big (max 10mb).',
  'already_invited': 'Invitation already has been sent.',
  'already_team_member': 'Looks like this account is already part of your team.',
  'default': 'Something went wrong',
  'file_dimensions_error': 'Image dimensions should be minimum 1024x500',
  'file_upload_error': 'Could not upload file',
  'file_validation_error': 'Make sure file size does not exceed 10mb and has supported file type (JPEG, PNG)',
  'missing_payment_method': 'Please choose a payment method',
  'plan_already_active': 'Plan is already active',
  'plan_slots_less_than_active':
    "You have more active job openings than selected plan allows. Please pause or stop ones you don't need, to downgrade.",
  'wrong_email': 'Please enter valid e-mail address',
};
